<template>
  <div></div>
</template>
<script>

import {GetCloudImageReportInfoByThirdVistParm,GetCloudImageConfigInfoByReportID} from '@/api/CloudFilmService'
import { EncryptAES } from '../../utils/stringUtils'
import enums from '@/utils/enums'
import * as cacheManage from '../../utils/cacheUtils'
export default {
  data() {
    return {
    };
  },
  activated() {
    this.$nextTick(() => {
        this.OpenReportView()
    });
  },
  methods: {
    OpenReportView(){
      var ExaminationID=this.$route.query.e
      var PatientID=this.$route.query.p
      var Name=this.$route.query.n
      var VistType=this.$route.query.t
      var HospitalNumber=this.$route.query.h
      if(!ExaminationID){
        this.$notify('参数e不能为空！' )
        return
      }
      if(!PatientID){
        this.$notify('参数p不能为空！' )
        return
      }
      if(!Name){
        this.$notify('参数n不能为空！' )
        return
      }
      if(!HospitalNumber){
        this.$notify('参数h不能为空！' )
        return
      }
      if(!VistType){
        this.$notify('参数t不能为空！' )
        return
      }else{
        if(VistType!=='1'&&VistType!=='2'){
          this.$notify('参数t非法！' )
          return
        }
      }
      GetCloudImageReportInfoByThirdVistParm({ExaminationID:ExaminationID,PatientID:PatientID,PatientName:Name,HospitalNumber:HospitalNumber}).then(res=>{
        if(res.Success){
          cacheManage.SetIsLogin(true)
          if(VistType==='1'){
            var path = `/login?isShare=${EncryptAES('1')}&dateTime=${EncryptAES(
            this.moment().add(5, 'minutes').format('YYYYMMDDHHmmss'))}&id=${res.Result.ID}&securityCode=${res.Result.SecurityCode}`
            this.$router.push({path:path})
          }
          if(VistType==='2'){
            GetCloudImageConfigInfoByReportID({ReportID:res.Result.ID}).then(resp=>{
              if(resp.Success){
                if(resp.Result.CloudImagePACSType===enums.CloudImagePACSTypes.ELPACS.value){
                  this.$router.push({
                    path: '/dicomView',
                    query: { reportInfoID: res.Result.ID },
                  })
                }else{
                  this.$router.push({
                    path: '/thirdDicomView',
                    query: { ExaminationID: EncryptAES(res.Result.ExaminationID), PatientID: EncryptAES(res.Result.PatientID),WebPacsURL:EncryptAES(resp.Result.WPACSPrePath) },
                  })
                }
              }
            })
          }
        }
      })
    }
  }
};
</script>